import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { DataService } from 'src/app/main/shared/services/data.service';
import { isNullOrUndefined } from 'util';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-heat-log-sidebar',
  templateUrl: './heat-log-sidebar.component.html',
  styleUrls: ['./heat-log-sidebar.component.scss']
})
export class HeatLogSidebarComponent implements OnInit, OnDestroy {

  // @Input() labelStrings: any;
  // @Input() blockNum: any;
  // @Output() playPos = new EventEmitter<any>();

  queryParams: any = {};
  startYear: number = 2016;
  endYear: number = 2026;
  years: number[] = [];

  get endYears(): number[] {
    return this.years.filter(y => y >= this.startYear);
  }

  subscriptions: any = [];
  isInitialLoad: boolean = false;
  destroy: any = new Subject();
  sessionStorage: any = {
    params: {}
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private utils: UtilsService,
    private dataService: DataService
  ) {
    for (let y = 2016; y <= 2026; y++) { this.years.push(y); }
  }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents();
    this.setParams();
  }

  subscribeEvents() {
    const selectedParamsRef = this.utils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        this.queryParams = params;
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        this.sessionStorage.params = { ...this.queryParams };
        if (Object.keys(this.queryParams).length) {
          this.utils.setSelectedParams(this.queryParams);
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        if (!isNullOrUndefined(this.queryParams.startYear)) {
          this.startYear = this.queryParams.startYear;
        }
        if (!isNullOrUndefined(this.queryParams.endYear)) {
          this.endYear = this.queryParams.endYear;
        }
      }
    });
    this.subscriptions.push(selectedParamsRef);
  }

  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedParams();
    }
    this.isInitialLoad = false;
  }

  requestSelectedParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    currentUrlParams['component'] = 'HEATLOG';
    if (this.isInitialLoad) {
      let metaInfo: any = localStorage.getItem('metaInfo');
      let metaInfoJson: any = !isNullOrUndefined(metaInfo) ? JSON.parse(metaInfo) : {};
      let finalMetaInfo = metaInfoJson;
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      const userLocationConfig = this.dataService.formQuerParamsVariables(finalMetaInfo.userDetailsJson.data.location, finalMetaInfo.userDetailsJson.data.locType);
      const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
      currentUrlParams['pUUID'] = currentLocations[1];
      currentUrlParams['locName'] = currentLocations[0];
      currentUrlParams['locType'] = userLocationConfig.types.pType;
      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      currentUrlParams['startYear'] = this.startYear;
      currentUrlParams['endYear'] = this.endYear;
      currentUrlParams['temperature'] = 40
      this.isInitialLoad = false;
    }
    this.utils.setSelectedParams(currentUrlParams);
  }

  onStartYearChange() {
    if (this.endYear < this.startYear) {
      this.endYear = this.startYear;
    }
  }

  onSubmit() {
    this.utils.setSelectedParams({ ...this.queryParams, startYear: this.startYear, endYear: this.endYear });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }
}
